const u = (id, w = 600, h = 400) =>
  `https://images.unsplash.com/${id}?w=${w}&h=${h}&fit=crop&q=80&auto=format`;

export const menuData = {
  classic: {
    name: 'Classic Café Menu', emoji: '☕',
    description: 'Timeless favorites crafted with care and tradition',
    categories: [
      {
        name: 'Beverages', icon: '🥤',
        items: [
          { name: 'Espresso', desc: 'Rich, bold, and intense', price: 99, image: u('photo-1510707577719-ae7c14805e3a') },
          { name: 'Cappuccino', desc: 'Creamy foam meets espresso', price: 129, image: u('photo-1572442388796-11668a67e53d') },
          { name: 'Latte', desc: 'Smooth, velvety coffee with steamed milk', price: 139, image: u('photo-1461023058943-07fcbe16d735') },
          { name: 'Cold Coffee', desc: 'Chilled and refreshing coffee blend', price: 119, image: u('photo-1517701550927-30cf4ba1dba5') },
          { name: 'Iced Tea (Lemon)', desc: 'Cool citrus refreshment', price: 89, image: u('photo-1556679343-c7306c1976bc') },
          { name: 'Iced Tea (Peach)', desc: 'Sweet peach iced delight', price: 89, image: u('photo-1544145945-f90425340c7e') },
          { name: 'Fresh Lime Soda', desc: 'Fizzy, tangy, and refreshing', price: 69, image: u('photo-1513558161293-cdaf765ed2fd') },
        ],
      },
      {
        name: 'Snacks', icon: '🍔',
        items: [
          { name: 'Veg Sandwich', desc: 'Fresh veggies in toasted bread', price: 99, image: u('photo-1528735602780-2552fd46c7af') },
          { name: 'Cheese Burger', desc: 'Juicy patty with melted cheese', price: 149, image: u('photo-1568901346375-23c9450c58cd') },
          { name: 'French Fries', desc: 'Crispy golden potato fries', price: 89, image: u('photo-1573080496219-bb080dd4f877') },
          { name: 'Garlic Bread', desc: 'Warm, buttery, and garlicky', price: 79, image: u('photo-1619535860434-ba1d8fa12536') },
        ],
      },
      {
        name: 'Desserts', icon: '🍰',
        items: [
          { name: 'Chocolate Cake', desc: 'Rich and decadent chocolate layers', price: 149, image: u('photo-1578985545062-69928b1d9587') },
          { name: 'Brownie with Ice Cream', desc: 'Warm brownie meets cold ice cream', price: 159, image: u('photo-1606313564200-e75d5e30476c') },
          { name: 'Cheesecake', desc: 'Creamy, smooth, and divine', price: 179, image: u('photo-1533134242443-d4fd215305ad') },
        ],
      },
    ],
  },
  trendy: {
    name: 'Trendy Café Menu', emoji: '🧋',
    description: 'Modern flavors for the adventurous and bold',
    categories: [
      {
        name: 'Special Drinks', icon: '🧋',
        items: [
          { name: 'Oreo Shake', desc: 'Cookies and cream blended bliss', price: 159, image: u('photo-1572490122747-3968b75cc699') },
          { name: 'KitKat Shake', desc: 'Crunchy wafer chocolate shake', price: 169, image: u('photo-1541658016709-82535e94bc69') },
          { name: 'Cold Brew Coffee', desc: 'Slow-steeped for smooth intensity', price: 149, image: u('photo-1504630083234-14187a9df0f5') },
          { name: 'Mojito (Mint)', desc: 'Fresh minty citrus cooler', price: 119, image: u('photo-1551538827-9c037cb4f32a') },
          { name: 'Mojito (Blueberry)', desc: 'Sweet blueberry twist', price: 129, image: u('photo-1560508179-b2c9a3f8e92b') },
        ],
      },
      {
        name: 'Quick Bites', icon: '🍕',
        items: [
          { name: 'Margherita Pizza', desc: 'Classic tomato, mozzarella, basil', price: 199, image: u('photo-1574071318508-1cdbab80d002') },
          { name: 'Pasta (White Sauce)', desc: 'Creamy alfredo perfection', price: 179, image: u('photo-1621996346565-e3dbc646d9a9') },
          { name: 'Pasta (Red Sauce)', desc: 'Bold tomato-based Italian classic', price: 169, image: u('photo-1563379926898-05f4575a45d8') },
          { name: 'Loaded Nachos', desc: 'Crunchy chips with cheesy toppings', price: 149, image: u('photo-1513456852971-30c0b8199d4d') },
        ],
      },
      {
        name: 'Sweet Treats', icon: '🍩',
        items: [
          { name: 'Donuts', desc: 'Glazed, sprinkled, and irresistible', price: 79, image: u('photo-1527904324834-3bda86da6771') },
          { name: 'Waffles', desc: 'Crispy golden with toppings', price: 139, image: u('photo-1562376552-0d160a2f238d') },
          { name: 'Pancakes', desc: 'Fluffy stacks of morning happiness', price: 129, image: u('photo-1567620905732-2d1ec7ab7445') },
        ],
      },
    ],
  },
  healthy: {
    name: 'Healthy Café Menu', emoji: '🌿',
    description: 'Fresh, wholesome, and nourishing choices',
    categories: [
      {
        name: 'Healthy Drinks', icon: '🥗',
        items: [
          { name: 'Green Tea', desc: 'Light, refreshing, antioxidant-rich', price: 69, image: u('photo-1564890369478-c89ca6d9cde9') },
          { name: 'Detox Water', desc: 'Infused with cucumber, lemon & mint', price: 59, image: u('photo-1536935338788-846bb9981813') },
          { name: 'Fresh Fruit Juice', desc: 'Seasonal fruits, freshly squeezed', price: 99, image: u('photo-1600271886742-f049cd451bba') },
        ],
      },
      {
        name: 'Light Food', icon: '🥙',
        items: [
          { name: 'Veg Salad', desc: 'Crispy, fresh, and colorful', price: 99, image: u('photo-1512621776951-a57141f2eefd') },
          { name: 'Grilled Sandwich', desc: 'Toasted with healthy fillings', price: 109, image: u('photo-1528735602780-2552fd46c7af') },
          { name: 'Smoothie Bowl', desc: 'Thick, fruity, topped with goodness', price: 149, image: u('photo-1590301157890-4810ed352733') },
        ],
      },
    ],
  },
};

export const tabs = [
  { key: 'classic', label: 'Classic', emoji: '☕' },
  { key: 'trendy', label: 'Trendy', emoji: '🧋' },
  { key: 'healthy', label: 'Healthy', emoji: '🌿' },
];
